var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitenotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97852 4.125C3.56452 4.125 3.22852 3.789 3.22852 3.375V0.75C3.22852 0.336 3.56452 0 3.97852 0C4.39252 0 4.72852 0.336 4.72852 0.75V3.375C4.72852 3.789 4.39252 4.125 3.97852 4.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54102 4.125C7.12702 4.125 6.79102 3.789 6.79102 3.375V0.75C6.79102 0.336 7.12702 0 7.54102 0C7.95502 0 8.29102 0.336 8.29102 0.75V3.375C8.29102 3.789 7.95502 4.125 7.54102 4.125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1045 4.125C10.6905 4.125 10.3545 3.789 10.3545 3.375V0.75C10.3545 0.336 10.6905 0 11.1045 0C11.5185 0 11.8545 0.336 11.8545 0.75V3.375C11.8545 3.789 11.5185 4.125 11.1045 4.125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6035 1.6875H2.47852C1.34077 1.6875 0.416016 2.61225 0.416016 3.75V15.9375C0.416016 17.0752 1.34077 18 2.47852 18H12.6035C13.7413 18 14.666 17.0752 14.666 15.9375V3.75C14.666 2.61225 13.7413 1.6875 12.6035 1.6875ZM4.16602 6H7.91602C8.33002 6 8.66602 6.336 8.66602 6.75C8.66602 7.164 8.33002 7.5 7.91602 7.5H4.16602C3.75202 7.5 3.41602 7.164 3.41602 6.75C3.41602 6.336 3.75202 6 4.16602 6ZM11.666 13.5H4.16602C3.75202 13.5 3.41602 13.164 3.41602 12.75C3.41602 12.336 3.75202 12 4.16602 12H11.666C12.08 12 12.416 12.336 12.416 12.75C12.416 13.164 12.08 13.5 11.666 13.5ZM11.666 10.5H4.16602C3.75202 10.5 3.41602 10.164 3.41602 9.75C3.41602 9.336 3.75202 9 4.16602 9H11.666C12.08 9 12.416 9.336 12.416 9.75C12.416 10.164 12.08 10.5 11.666 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitenotes);
export default __webpack_public_path__ + "static/media/whitenotes.8ccd6af7c5c2e63d0013b80de1abad21.svg";
export { ForwardRef as ReactComponent };